import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";
import { AppSettingsIcon } from "../../Icon/AppSettingsIcon";

export const SettingsToolButton = (props: IconButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={Translations.Settings}
        icon={<AppSettingsIcon />}
    />
);
